import React from "react"
import { Badge, BadgeGroup, BadgeVariant } from "./SidebarBadge.styled"

type Props = {
  count: number
  variant?: BadgeVariant
}

const SidebarBadge = ({ count, variant = "failed" }: Props) => {
  if (count <= 0) return null

  return <Badge $variant={variant}>{count > 99 ? "99+" : count}</Badge>
}

type SplitProps = {
  failedCount: number
  approvalCount: number
}

export const SidebarBadgeSplit = ({ failedCount, approvalCount }: SplitProps) => {
  if (failedCount <= 0 && approvalCount <= 0) return null

  return (
    <BadgeGroup>
      <SidebarBadge variant="failed" count={failedCount} />
      <SidebarBadge variant="approval" count={approvalCount} />
    </BadgeGroup>
  )
}

export default SidebarBadge
